import React, { Component } from 'react';
import { scrolly } from '../helper.js'
import '../styles/intro.scss';


import lizard from "../img/lizard.png";
import wave from "../img/waving-hand.png";
import coder from "../img/woman-tech.png";


class Intro extends Component {
  componentDidMount() {
    scrolly();
  }
  render() {
    return (
      <div>
        <section id="topper">

        <div className="greeting">
          <span className="animate-1">Hi, I'm Andrea Roberson. </span>
          <span className="animate-1">You can

            <span className="highlight">call me Andy.
                <div className="hello">
                  <img src={wave} alt="Waving hand" />
                </div>
            </span>
          </span>

          <span className="animate-1">I'm a
            <span className="highlight"> creative developer </span> focused on using code and design in innovative ways. <div className="tech"><img src={coder} alt="Woman technologist" /></div>
          </span>

          <span className="animate-1">I started coding when I was 11 and found the HTML / CSS tutorials on Neopets.com.
            <div className="lizard"><img src={lizard} alt="Lizard" /></div>
          </span>

          <div className="line4">
            <span className="new-line animate-1">I never really stopped.</span>
          </div>
        </div>
        </section>
      </div>
    );
  }
}

export default Intro;
